import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.targetRoute,
    class: "btn btn-icon btn-primary"
  }, {
    default: _withCtx(() => [
      _createElementVNode("i", {
        class: _normalizeClass(["mas fw-light", _ctx.iconClass])
      }, "edit", 2)
    ]),
    _: 1
  }, 8, ["to"]))
}